import React from "react";
import {COLORS} from "../model";
import './Colors.css';
import {animation} from "../stores/AnimationStore";

export const Colors = () => {

    const selectColor = (code: number) => {
        animation.addColor(code);
        // animation.newInstructions(formula);
    }

    return <div className="colors">
        {Object.entries(COLORS).map(([code, name]) =>
            <div key={name} className={`color linn-color-${code}`} onClick={() => selectColor(parseInt(code, 10))}>
                <div>{name}</div>
                <div>{code}</div>
            </div>)}
    </div>;
}